module.exports = __webpack_public_path__ + "assets/images/route-planning-302a8b68f6998ab2a5c7c07a69a9b4ee.png";